(() => {
  'use strict';

  /* PN_PHASE8_ADMIN_OPS_V1 */

  const esc = value =>
    String(value ?? '')
      .replaceAll('&','&amp;')
      .replaceAll('<','&lt;')
      .replaceAll('>','&gt;')
      .replaceAll('"','&quot;')
      .replaceAll("'","&#039;");


  function money(
    value,
    currency = 'INR'
  ) {
    return new Intl.NumberFormat(
      'en-IN',
      {
        style:'currency',
        currency:currency || 'INR',
        maximumFractionDigits:2
      }
    ).format(
      Number(value || 0)
    );
  }


  function dateText(value) {

    if (!value) {
      return '—';
    }

    const date =
      new Date(value);

    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '—';
    }

    return date.toLocaleString(
      'en-IN'
    );
  }


  async function rpc(
    name,
    body = {}
  ) {

    return window.PeerNestDB
      .request(
        `rpc/${name}`,
        '',
        {
          method:'POST',
          body
        }
      );
  }


  async function rest(
    path,
    query = ''
  ) {

    return window.PeerNestDB
      .request(
        path,
        query
      );
  }


  function closeDrawer() {

    document
      .querySelector(
        '[data-pn8ops-drawer]'
      )
      ?.remove();

  }


  function shell(
    title,
    eyebrow = ''
  ) {

    closeDrawer();

    const modal =
      document.createElement(
        'div'
      );

    modal.className =
      'pn8ops-modal';

    modal.setAttribute(
      'data-pn8ops-drawer',
      ''
    );

    modal.innerHTML = `
      <div
        class="pn8ops-backdrop"
        data-pn8ops-close
      ></div>

      <aside class="pn8ops-panel">

        <div class="pn8ops-head">

          <div>
            <span>
              ${esc(eyebrow)}
            </span>

            <h2>
              ${esc(title)}
            </h2>
          </div>

          <button
            type="button"
            class="pn8ops-close"
            data-pn8ops-close
          >
            ×
          </button>

        </div>

        <div
          class="pn8ops-body"
          data-pn8ops-body
        >
          <div class="pn8ops-loading">
            Loading…
          </div>
        </div>

      </aside>
    `;

    document.body
      .appendChild(
        modal
      );

    modal.addEventListener(
      'click',
      event => {

        if (
          event.target.closest(
            '[data-pn8ops-close]'
          )
        ) {
          closeDrawer();
        }

      }
    );

    return modal
      .querySelector(
        '[data-pn8ops-body]'
      );
  }


  function statusPill(
    value
  ) {

    const state =
      String(
        value ||
        'unknown'
      )
        .toLowerCase();

    return `
      <span
        class="pn8ops-pill"
        data-state="${esc(state)}"
      >
        ${esc(state)}
      </span>
    `;
  }


  /* =========================================================
     EVENT PARTICIPANTS
  ========================================================= */

  async function openEventParticipants(
    eventId
  ) {

    const body =
      shell(
        'Participants',
        'EVENT OPERATIONS'
      );


    try {

      const result =
        await rpc(
          'admin_list_event_participants_v1',
          {
            p_event_id:
              eventId
          }
        );


      const event =
        result?.event ||
        {};

      const rows =
        Array.isArray(
          result?.registrations
        )
          ? result.registrations
          : [];


      body.innerHTML = `

        <div class="pn8ops-event-summary">

          <article>
            <span>EVENT</span>
            <strong>
              ${esc(
                event.title ||
                'Event'
              )}
            </strong>
          </article>


          <article>
            <span>PARTICIPATION</span>
            <strong>
              ${esc(
                event.participation_type ||
                'individual'
              )}
            </strong>
          </article>


          <article>
            <span>PRICE</span>
            <strong>
              ${money(
                event.price,
                event.currency
              )}
            </strong>
            <small>
              ${esc(
                event.fee_type ||
                'per registration'
              )}
            </small>
          </article>


          <article>
            <span>REGISTRATIONS</span>
            <strong>
              ${rows.length}
            </strong>
          </article>

        </div>


        ${
          !rows.length
            ? `
              <div class="pn8ops-empty">
                No registrations yet.
              </div>
            `
            : `
              <div class="pn8ops-registration-list">

                ${rows
                  .map(
                    row => {

                      const team =
                        String(
                          row.registration_type ||
                          ''
                        ) ===
                        'team';


                      const members =
                        Array.isArray(
                          row.team_members
                        )
                          ? row.team_members
                          : [];


                      return `

                        <article
                          class="pn8ops-registration"
                        >

                          <div class="pn8ops-reg-head">

                            <div>

                              <span class="pn8ops-number">
                                #${esc(
                                  row.participant_number
                                )}
                              </span>

                              <div>

                                <strong>
                                  ${esc(
                                    team
                                      ? (
                                          row.team_name ||
                                          'Unnamed team'
                                        )
                                      : (
                                          row.name ||
                                          'Participant'
                                        )
                                  )}
                                </strong>

                                <small>
                                  ${
                                    team
                                      ? `${esc(
                                          row.participant_count ||
                                          members.length
                                        )} participants`
                                      : esc(
                                          row.email ||
                                          ''
                                        )
                                  }
                                </small>

                              </div>

                            </div>


                            <div class="pn8ops-reg-status">

                              ${statusPill(
                                row.registration_status
                              )}

                              ${statusPill(
                                row.payment_status ||
                                (
                                  Number(
                                    row.event_price ||
                                    0
                                  ) > 0
                                    ? 'unpaid'
                                    : 'free'
                                )
                              )}

                            </div>

                          </div>


                          ${
                            team
                              ? `
                                <div class="pn8ops-team">

                                  <span>
                                    TEAM MEMBERS
                                  </span>

                                  ${
                                    members.length
                                      ? members
                                          .map(
                                            (
                                              member,
                                              index
                                            ) => `
                                              <div
                                                class="pn8ops-member"
                                              >
                                                <b>
                                                  ${
                                                    index +
                                                    1
                                                  }.
                                                  ${esc(
                                                    member.name ||
                                                    'Participant'
                                                  )}
                                                </b>

                                                <small>
                                                  ${esc(
                                                    member.email ||
                                                    ''
                                                  )}

                                                  ${
                                                    member.is_captain
                                                      ? ' · Captain'
                                                      : ''
                                                  }
                                                </small>
                                              </div>
                                            `
                                          )
                                          .join('')
                                      : `
                                        <div class="pn8ops-muted">
                                          No team-member records yet.
                                        </div>
                                      `
                                  }

                                </div>
                              `
                              : ''
                          }


                          <div class="pn8ops-reg-grid">

                            <div>
                              <span>Registration</span>
                              <strong>
                                ${esc(
                                  row.registration_type ||
                                  'individual'
                                )}
                              </strong>
                            </div>

                            <div>
                              <span>Ticket</span>
                              <strong>
                                ${esc(
                                  row.ticket_code ||
                                  '—'
                                )}
                              </strong>
                            </div>

                            <div>
                              <span>Price model</span>
                              <strong>
                                ${esc(
                                  row.fee_type ||
                                  '—'
                                )}
                              </strong>
                            </div>

                            <div>
                              <span>Amount paid</span>
                              <strong>
                                ${
                                  row.amount_charged !==
                                  null &&
                                  row.amount_charged !==
                                  undefined
                                    ? money(
                                        row.amount_charged,
                                        row.currency
                                      )
                                    : (
                                        Number(
                                          row.event_price ||
                                          0
                                        ) === 0
                                          ? 'Free'
                                          : '—'
                                      )
                                }
                              </strong>
                            </div>

                            <div>
                              <span>Registered</span>
                              <strong>
                                ${esc(
                                  dateText(
                                    row.registered_at
                                  )
                                )}
                              </strong>
                            </div>

                            <div>
                              <span>Confirmed</span>
                              <strong>
                                ${esc(
                                  dateText(
                                    row.confirmed_at
                                  )
                                )}
                              </strong>
                            </div>

                          </div>


                          ${
                            row.provider_payment_id
                              ? `
                                <div class="pn8ops-payment-ref">
                                  Razorpay:
                                  ${esc(
                                    row.provider_payment_id
                                  )}
                                </div>
                              `
                              : ''
                          }

                        </article>
                      `;
                    }
                  )
                  .join('')}

              </div>
            `
        }
      `;

    }
    catch (error) {

      body.innerHTML = `
        <div class="pn8ops-error">
          ${esc(
            error?.message ||
            'Could not load participants.'
          )}
        </div>
      `;

    }

  }


  /* =========================================================
     COMMUNITY MODERATION
  ========================================================= */

  async function loadCommunities() {

    const rows =
      await rpc(
        'admin_list_communities_v1'
      );

    return Array.isArray(rows)
      ? rows
      : [];

  }


  async function openCommunityChooser() {

    const body =
      shell(
        'Community moderation',
        'TRUST & SAFETY'
      );


    const communities =
      await loadCommunities();


    if (!communities.length) {

      body.innerHTML = `
        <div class="pn8ops-empty">
          No communities found.
        </div>
      `;

      return;
    }


    body.innerHTML = `

      <div class="pn8ops-community-list">

        ${communities
          .map(
            row => `

              <button
                type="button"
                class="pn8ops-community-row"
                data-pn8ops-community="${esc(
                  row.id
                )}"
              >

                <div>

                  <strong>
                    ${esc(
                      row.name ||
                      row.title ||
                      row.slug ||
                      'Community'
                    )}
                  </strong>

                  <small>
                    ${esc(
                      row.slug ||
                      ''
                    )}
                  </small>

                </div>

                <span>
                  Moderate →
                </span>

              </button>
            `
          )
          .join('')}

      </div>
    `;


    body.addEventListener(
      'click',
      event => {

        const button =
          event.target.closest(
            '[data-pn8ops-community]'
          );


        if (!button) {
          return;
        }


        openCommunityModeration(
          button.dataset
            .pn8opsCommunity
        );

      }
    );

  }


  function contentActions(
    type,
    row
  ) {

    const removed =
      ['hidden','removed']
        .includes(
          String(
            row.status ||
            ''
          )
        );


    return `

      <div class="pn8ops-actions">

        ${
          removed
            ? `
              <button
                type="button"
                data-pn8ops-content="${esc(
                  row.id
                )}"
                data-content-type="${esc(
                  type
                )}"
                data-action="restore"
              >
                Restore
              </button>
            `
            : `
              <button
                type="button"
                data-pn8ops-content="${esc(
                  row.id
                )}"
                data-content-type="${esc(
                  type
                )}"
                data-action="hide"
              >
                Hide
              </button>

              <button
                type="button"
                class="is-danger"
                data-pn8ops-content="${esc(
                  row.id
                )}"
                data-content-type="${esc(
                  type
                )}"
                data-action="remove"
              >
                Remove
              </button>
            `
        }


        ${
          type === 'post'
            ? `
              <button
                type="button"
                data-pn8ops-content="${esc(
                  row.id
                )}"
                data-content-type="post"
                data-action="${
                  row.is_pinned
                    ? 'unpin'
                    : 'pin'
                }"
              >
                ${
                  row.is_pinned
                    ? 'Unpin'
                    : 'Pin'
                }
              </button>
            `
            : ''
        }

      </div>
    `;

  }


  async function openCommunityModeration(
    communityId,
    notice = ''
  ) {

    const body =
      shell(
        'Community moderation',
        'LIVE MODERATION'
      );


    try {

      const data =
        await rpc(
          'admin_get_community_moderation_v1',
          {
            p_community_id:
              communityId
          }
        );


      const community =
        data?.community ||
        {};

      const posts =
        Array.isArray(
          data?.posts
        )
          ? data.posts
          : [];

      const comments =
        Array.isArray(
          data?.comments
        )
          ? data.comments
          : [];

      const members =
        Array.isArray(
          data?.members
        )
          ? data.members
          : [];


      body.innerHTML = `

        ${
          notice
            ? `
              <div class="pn8ops-notice">
                ${esc(notice)}
              </div>
            `
            : ''
        }


        <div class="pn8ops-community-title">

          <div>
            <span>COMMUNITY</span>

            <h3>
              ${esc(
                community.name ||
                community.title ||
                community.slug ||
                'Community'
              )}
            </h3>
          </div>


          <button
            type="button"
            data-pn8ops-back-communities
          >
            ← Communities
          </button>

        </div>


        <div class="pn8ops-tabs">

          <button
            type="button"
            class="is-active"
            data-pn8ops-tab="posts"
          >
            Posts (${posts.length})
          </button>

          <button
            type="button"
            data-pn8ops-tab="comments"
          >
            Comments (${comments.length})
          </button>

          <button
            type="button"
            data-pn8ops-tab="members"
          >
            Members (${members.length})
          </button>

        </div>


        <section
          data-pn8ops-panel="posts"
        >

          ${
            posts.length
              ? posts
                  .map(
                    post => `

                      <article class="pn8ops-message">

                        <div class="pn8ops-message-head">

                          <div>

                            <strong>
                              ${
                                !post.author_id
                                  ? 'PeerNest Bot'
                                  : esc(
                                      post.author_name ||
                                      'PeerNest User'
                                    )
                              }
                            </strong>

                            ${
                              !post.author_id
                                ? `
                                  <span class="pn8ops-bot">
                                    BOT
                                  </span>
                                `
                                : ''
                            }

                            <small>
                              ${esc(
                                dateText(
                                  post.created_at
                                )
                              )}
                            </small>

                          </div>

                          ${statusPill(
                            post.status
                          )}

                        </div>


                        ${
                          post.title
                            ? `
                              <h4>
                                ${esc(
                                  post.title
                                )}
                              </h4>
                            `
                            : ''
                        }


                        <p>
                          ${esc(
                            post.body ||
                            ''
                          )}
                        </p>


                        ${contentActions(
                          'post',
                          post
                        )}

                      </article>
                    `
                  )
                  .join('')
              : `
                <div class="pn8ops-empty">
                  No posts.
                </div>
              `
          }

        </section>


        <section
          data-pn8ops-panel="comments"
          hidden
        >

          ${
            comments.length
              ? comments
                  .map(
                    comment => `

                      <article class="pn8ops-message">

                        <div class="pn8ops-message-head">

                          <div>

                            <strong>
                              ${
                                !comment.author_id
                                  ? 'PeerNest Bot'
                                  : esc(
                                      comment.author_name ||
                                      'PeerNest User'
                                    )
                              }
                            </strong>

                            ${
                              !comment.author_id
                                ? `
                                  <span class="pn8ops-bot">
                                    BOT
                                  </span>
                                `
                                : ''
                            }

                            <small>
                              ${esc(
                                dateText(
                                  comment.created_at
                                )
                              )}
                            </small>

                          </div>

                          ${statusPill(
                            comment.status
                          )}

                        </div>


                        <p>
                          ${esc(
                            comment.body ||
                            ''
                          )}
                        </p>


                        ${contentActions(
                          'comment',
                          comment
                        )}

                      </article>
                    `
                  )
                  .join('')
              : `
                <div class="pn8ops-empty">
                  No comments.
                </div>
              `
          }

        </section>


        <section
          data-pn8ops-panel="members"
          hidden
        >

          ${
            members.length
              ? members
                  .map(
                    member => `

                      <article class="pn8ops-member-row">

                        <div>

                          <strong>
                            ${esc(
                              member.name ||
                              'PeerNest User'
                            )}
                          </strong>

                          <small>
                            ${esc(
                              member.email ||
                              ''
                            )}
                          </small>

                        </div>


                        <div class="pn8ops-member-state">

                          ${statusPill(
                            member.member_status
                          )}

                          ${statusPill(
                            member.account_status
                          )}

                        </div>


                        ${
                          String(
                            member.account_role ||
                            ''
                          ) !== 'admin'
                            ? `
                              <div class="pn8ops-actions">

                                <button
                                  type="button"
                                  data-pn8ops-member="${esc(
                                    member.user_id
                                  )}"
                                  data-member-action="left"
                                >
                                  Remove
                                </button>

                                <button
                                  type="button"
                                  class="is-danger"
                                  data-pn8ops-member="${esc(
                                    member.user_id
                                  )}"
                                  data-member-action="banned"
                                >
                                  Ban
                                </button>

                                <button
                                  type="button"
                                  class="is-danger"
                                  data-pn8ops-member="${esc(
                                    member.user_id
                                  )}"
                                  data-member-action="ban_suspend"
                                >
                                  Ban + suspend account
                                </button>

                              </div>
                            `
                            : `
                              <small>
                                Admin account protected
                              </small>
                            `
                        }

                      </article>
                    `
                  )
                  .join('')
              : `
                <div class="pn8ops-empty">
                  No members.
                </div>
              `
          }

        </section>
      `;


      body.addEventListener(
        'click',
        async event => {

          const back =
            event.target.closest(
              '[data-pn8ops-back-communities]'
            );


          if (back) {

            await openCommunityChooser();
            return;

          }


          const tab =
            event.target.closest(
              '[data-pn8ops-tab]'
            );


          if (tab) {

            const name =
              tab.dataset
                .pn8opsTab;


            body
              .querySelectorAll(
                '[data-pn8ops-tab]'
              )
              .forEach(
                node =>
                  node.classList
                    .toggle(
                      'is-active',
                      node === tab
                    )
              );


            body
              .querySelectorAll(
                '[data-pn8ops-panel]'
              )
              .forEach(
                panel => {

                  panel.hidden =
                    panel.dataset
                      .pn8opsPanel !==
                    name;

                }
              );

            return;

          }


          const content =
            event.target.closest(
              '[data-pn8ops-content]'
            );


          if (content) {

            const action =
              content.dataset
                .action;

            let reason =
              '';

            if (
              ['hide','remove']
                .includes(action)
            ) {

              reason =
                window.prompt(
                  'Moderation reason:',
                  ''
                ) || '';

            }


            content.disabled =
              true;


            try {

              await rpc(
                'admin_moderate_community_content_v1',
                {
                  p_content_type:
                    content.dataset
                      .contentType,

                  p_content_id:
                    content.dataset
                      .pn8opsContent,

                  p_action:
                    action,

                  p_reason:
                    reason ||
                    null
                }
              );


              await openCommunityModeration(
                communityId,
                `Content ${action} successful.`
              );

            }
            catch (error) {

              window.alert(
                error?.message ||
                'Moderation failed.'
              );

              content.disabled =
                false;

            }

            return;

          }


          const memberButton =
            event.target.closest(
              '[data-pn8ops-member]'
            );


          if (memberButton) {

            const action =
              memberButton.dataset
                .memberAction;

            const suspend =
              action ===
              'ban_suspend';

            const status =
              suspend
                ? 'banned'
                : action;


            const reason =
              window.prompt(
                'Reason for this action:',
                ''
              ) || 'Admin moderation';


            const yes =
              window.confirm(
                suspend
                  ? 'Ban this member and suspend their whole PeerNest account?'
                  : (
                      status === 'banned'
                        ? 'Ban this member from the community?'
                        : 'Remove this member from the community?'
                    )
              );


            if (!yes) {
              return;
            }


            memberButton.disabled =
              true;


            try {

              await rpc(
                'admin_set_community_member_status_v1',
                {
                  p_community_id:
                    communityId,

                  p_user_id:
                    memberButton.dataset
                      .pn8opsMember,

                  p_status:
                    status,

                  p_reason:
                    reason,

                  p_suspend_account:
                    suspend
                }
              );


              await openCommunityModeration(
                communityId,
                suspend
                  ? 'Member banned and account suspended.'
                  : `Member status changed to ${status}.`
              );

            }
            catch (error) {

              window.alert(
                error?.message ||
                'Member moderation failed.'
              );

              memberButton.disabled =
                false;

            }

          }

        }
      );

    }
    catch (error) {

      body.innerHTML = `
        <div class="pn8ops-error">
          ${esc(
            error?.message ||
            'Could not load community moderation.'
          )}
        </div>
      `;

    }

  }


  /* =========================================================
     GLOBAL ADMIN MODERATION LAUNCHER
  ========================================================= */

  function installLauncher() {

    if (
      document.querySelector(
        '[data-pn8ops-launch]'
      )
    ) {
      return;
    }


    const button =
      document.createElement(
        'button'
      );

    button.type =
      'button';

    button.className =
      'pn8ops-launch';

    button.setAttribute(
      'data-pn8ops-launch',
      ''
    );

    button.innerHTML = `
      <span>•••</span>
      Community moderation
    `;

    button.addEventListener(
      'click',
      openCommunityChooser
    );

    document.body
      .appendChild(
        button
      );

  }


  /* =========================================================
     REPLACE OLD EVENT "VIEW REGISTRATIONS" INSPECTOR
  ========================================================= */

  document.addEventListener(
    'click',
    event => {

      const inspect =
        event.target.closest(
          '[data-pn8a-inspect-event]'
        );


      if (!inspect) {
        return;
      }


      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      openEventParticipants(
        inspect.dataset
          .pn8aInspectEvent
      );

    },
    true
  );


  function init() {

    installLauncher();

  }


  if (
    window.PeerNestDB
  ) {

    init();

  }
  else {

    document.addEventListener(
      'peernest:supabase-ready',
      init,
      {
        once:true
      }
    );

  }


  window.PeerNestPhase8Ops = {
    participants:
      openEventParticipants,

    moderation:
      openCommunityChooser
  };

})();
